import { gql, TypedDocumentNode } from '@apollo/client';

import {
  TestGmailConnectionMutation,
  TestGmailConnectionMutationVariables,
} from '../generated';

export const TEST_GMAIL_CONNECTION: TypedDocumentNode<
  TestGmailConnectionMutation,
  TestGmailConnectionMutationVariables
> = gql`
  mutation TestGmailConnection($connectionId: ID!) {
    testGmailConnection(connectionId: $connectionId) {
      success
      errorMessage
      subjects
      fetchedCount
      resultSizeEstimate
    }
  }
`;
